import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PropTypes as AmktCommonPropTypes } from '@atlassian/amkt-common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddonDiscoveryPropTypes from "../../../AddonDiscovery/constants/proptypes/AddonDiscoveryPropTypes";
import CommonPropTypes from "../../constants/proptypes/CommonPropTypes";
import LargeHit from "./LargeHit";
import SmallHit from "./SmallHit";
export default class ResponsiveHit extends Component {
  render() {
    return this.props.screenClass === 'xs' ? /*#__PURE__*/React.createElement(SmallHit, {
      colSpan: this.props.colSpan,
      contentOverride: this.props.contentOverride,
      fromSearch: this.props.fromSearch,
      hit: this.props.hit,
      hitContext: this.props.hitContext,
      perspective: this.props.perspective,
      screenClass: this.props.screenClass,
      hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
      hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge
    }) : /*#__PURE__*/React.createElement(LargeHit, {
      colSpan: this.props.colSpan,
      contentOverride: this.props.contentOverride,
      fromSearch: this.props.fromSearch,
      hit: this.props.hit,
      hitContext: this.props.hitContext,
      onCategoryClick: this.props.onCategoryClick,
      perspective: this.props.perspective,
      screenClass: this.props.screenClass,
      stateChangeRequested: this.props.stateChangeRequested,
      overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
      hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
      hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge
    });
  }

}

_defineProperty(ResponsiveHit, "propTypes", {
  colSpan: CommonPropTypes.colSpan.isRequired,
  contentOverride: PropTypes.node,
  fromSearch: PropTypes.bool.isRequired,
  hit: AmktCommonPropTypes.requiredIf(CommonPropTypes.hit(), props => !props.contentOverride),
  hitContext: AmktCommonPropTypes.requiredIf(CommonPropTypes.hitContext, props => !props.contentOverride),
  onCategoryClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective,
  screenClass: CommonPropTypes.screenClass.isRequired,
  stateChangeRequested: PropTypes.func,
  overrideLargeHitRightContent: PropTypes.func,
  hasCloudSecurityBadge: PropTypes.bool,
  hasCloudFortifiedBadge: PropTypes.bool
});